import { createContext, useContext } from 'react';
// Import Types
import type { FilterTagsContextValue } from 'types';

/**
 * Exposes the active filter chips and the save / saved-filters actions of the nearest `FilterTagsProvider`
 * so that `DataTable` can render them inside its compact header without prop drilling.
 */
export const FilterTagsContext = createContext<Nullable<FilterTagsContextValue>>(null);

/**
 * Returns the nearest `FilterTagsProvider` value, or `null` when the table is rendered outside a provider.
 */
export const useFilterTagsContext = (): Nullable<FilterTagsContextValue> => useContext(FilterTagsContext);
